<div class="pt-3" *ngIf="!accountService.getMyAccount().is_organization_admin">
  <h2>You do not have permission to manage staff.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 mb-6"
     *ngIf="accountService.getMyAccount().is_organization_admin && serverError === null">

  <h2>Staff User Admin <span *ngIf="loadingUsers" class="text-secondary">- Loading...</span></h2>

  <div class="alert alert-success" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="alert alert-info" role="alert"
       *ngIf="loadingSave">
    Loading...
  </div>

  <div class="alert alert-success" role="alert"
       *ngIf="successMessage">
    {{ successMessage }}
  </div>

  <div class="alert alert-danger" role="alert"
       *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="row">
    <div class="col-md order-md-first order-last">
      <input type="text" class="form-control mb-3"
             placeholder="Filter staff by email and name"
             [(ngModel)]="userFilters.search"
             (ngModelChange)="handleUserFilterChange()">
    </div>
    <div class="col-md order-md-last order-first">
      <select class="custom-select w-auto"
              [(ngModel)]="userFilters.is_active"
              (ngModelChange)="handleUserFilterChange()"
              name="statusFilter" id="statusFilter">
        <option [ngValue]="true">Status: Active</option>
        <option [ngValue]="false">Status: Removed</option>
      </select>
      <button routerLink="/users/add" type="button" class="btn btn-success float-right mb-3">Add Staff User</button>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">User Type</th>
        <th scope="col">
          <span ngbTooltip="Whether this user can log in to the Staff Site.">
            Login?
          </span>
        </th>
        <th scope="col">
          <span ngbTooltip="Whether this user has two-factor authentication enabled.">
            2FA?
          </span>
        </th>
        <th scope="col">
          <span ngbTooltip="Whether this user has a PIN for use with the Staff Site.">
            PIN?
          </span>
        </th>
        <th *ngIf="orgConfig && orgConfig.pos_software === OrgPOSSoftware.lightspeed"
            scope="col">
          <span ngbTooltip="Whether this user has a linked Lightspeed account.">
            Lightspeed?
          </span>
        </th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="userList && userList.results && (userList.count > 0)">
      <tr *ngFor="let user of userList.results">
        <td>{{ getStaffNameDisplay(user.first_name, user.last_name, user.email) }}</td>
        <td>
          {{ getUserTypeDisplay(user.user_type) }}
          <span *ngIf="user.is_organization_admin">(Admin)</span>
        </td>
        <td *ngIf="user.has_password" class="text-success">&#10004;</td><td *ngIf="!user.has_password" class="text-danger">&#10008;</td>
        <td *ngIf="user.otp_enabled" class="text-success">&#10004;</td><td *ngIf="!user.otp_enabled" class="text-danger">&#10008;</td>
        <td *ngIf="user.has_pin" class="text-success">&#10004;</td><td *ngIf="!user.has_pin" class="text-danger">&#10008;</td>
        <ng-container *ngIf="orgConfig && orgConfig.pos_software === OrgPOSSoftware.lightspeed">
          <td *ngIf="user.lightspeed_user_id !== ''" class="text-success">
            <span ngbTooltip="Username: {{ user.lightspeed_user_username }}">
              &#10004;
            </span>
          </td>
          <td *ngIf="user.lightspeed_user_id === ''" class="text-danger">&#10008;</td>
        </ng-container>
        <td style="padding-top: 6px; padding-bottom: 6px;">
          <div class="dropdown dropleft">
            <button class="btn btn-primary float-right dropdown-toggle"
                    style="padding-top: 3px; padding-bottom: 3px;"
                    type="button" id="manageUserButton{{ user.id }}"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Manage
            </button>
            <div class="dropdown-menu"
                 attr.aria-labelledby="manageUserButton{{ user.id }}">
              <a class="dropdown-item"
                 routerLink="/users/{{ user.id }}">
                Edit
              </a>
              <a *ngIf="orgConfig && orgConfig.pos_software === OrgPOSSoftware.lightspeed"
                 class="dropdown-item"
                 href="#"
                 (click)="$event.preventDefault(); openSetLightspeedUserModal(user);">
                Link Lightspeed User
              </a>
              <a class="dropdown-item text-success" href="#"
                 *ngIf="!user.is_active"
                 [class.disabled]="loadingUsers"
                 (click)="$event.preventDefault();restoreUser(user);">
                Restore
              </a>
              <a class="dropdown-item text-danger" href="#"
                 *ngIf="user.is_active"
                 [class.disabled]="loadingUsers"
                 (click)="$event.preventDefault();removeUser(user);">
                Retire
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!(userList && userList.results && (userList.count > 0))">
      <tr>
        <td colspan="99">
          {{ loadingUsers ? 'Loading...' : 'No staff users' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="pageNumber = 1;loadUsers()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="User pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
